import { useLocation } from 'react-router-dom';
import locales from '../../locales.json';
import { m } from 'motion/react';

const { STEPS_TEXTS } = locales;

// Poradi kroku registrace 
const STEPS = ['email', 'registration', 'completion'];

const STEP_BY_PATH = {
  '/verify-email': STEPS[0],
  '/register': STEPS[1],
};

const TRANSITION = { duration: .22, ease: [.16, 1, .3, 1] };


const Breadcrumbs = ({ current }) => {
  const { pathname } = useLocation();
  const step = current ?? STEP_BY_PATH[pathname];

  if (!step) return null;

  const currentIndex = STEPS.indexOf(step);

  return (
    <nav className="steps" aria-label={STEPS_TEXTS.ariaLabel}>
      <ol className="steps__list">
        {STEPS.map((step, index) => {
          const state =
            index < currentIndex ? 'is-done' : index === currentIndex ? 'is-current' : '';
          const isCurrent = currentIndex === STEPS.indexOf(step);

          return (
            <li key={step} className={['steps__item', state].filter(Boolean).join(' ')}>
              <span className="steps__label">
                {STEPS_TEXTS[step]}

                {isCurrent && (
                  <m.span
                    layoutId="steps-underline"
                    className="steps__underline"
                    transition={TRANSITION}
                  />
                )}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
